'use strict';

const countryCodes = require('./../countryCodes');
const keywords = require('./../keywords');

var options3Ctrl = ['$uibModal', "$translate", "dialog", "$timeout", function ($uibModal, $translate, dialog, $timeout) {
    var _this = this;
    _this.editMode = [];
    _this.allowedKeywords = keywords; // Palabras clave permitidas

    function validateContactValue(rawValue) {
        var value = rawValue.trim().replace(/\"/g, '');
        var isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        var isWaNumber = /^wa:(\+?\d{8,})(?:\|[^\|]+)?$/.test(value);
        var isFieldId = /^field:[a-zA-Z0-9]{8,}(?:\|[^\|]+)?$/.test(value);
        var isKeyword = _this.allowedKeywords.find(function (elem) { return elem.id === value; });

        if (isEmail) {
            value = value.toLowerCase();
        }
        if (isEmail || isWaNumber || isKeyword || isFieldId) {
            return value;
        }
        return null;
    }

    function parseContactsFromClipboard(clipboardText) {
        var parsed = clipboardText.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        if (!parsed || parsed.length === 0) {
            return { validOptions: [], invalidValues: [] };
        }

        var usedKeys = {};
        var validOptions = [];
        var invalidValues = [];

        parsed.forEach(function (rawValue) {
            var trimmed = rawValue.trim().replace(/\"/g, '');
            if (!trimmed) {
                return;
            }

            var value = validateContactValue(rawValue);
            if (!value) {
                invalidValues.push(trimmed);
                return;
            }

            var key = value.split('|')[0];
            if (usedKeys[key]) {
                return;
            }
            usedKeys[key] = true;
            validOptions.push(value);
        });

        return { validOptions: validOptions, invalidValues: invalidValues };
    }

    _this.addOption = function (newValue) {
        if (newValue) {
            _this.options = _this.options || [];
            newValue = newValue.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);

            newValue = newValue || [];
            const invalidValues = [];

            newValue = newValue.map(function (value) {
                var validated = validateContactValue(value);
                if (validated) {
                    return validated;
                }
                invalidValues.push(value.trim().replace(/\"/g, ''));
                return null;
            }).filter(Boolean);
            if (invalidValues.length > 0) {
                this.errorMessage(
                    // $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_TITLE"),
                    // $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_START")
                    "Error: Contactos inválidos",
                    'Valores inválidos no agregados: ' + invalidValues.join(', ')
                );
            }
            newValue.forEach(function (value) {
                if (!_this.options.find(elem => elem.split('|')[0] === value.split('|')[0])) {
                    _this.options.push(value);
                }
            });

            _this.newOption = null;
        } else {
            toast.error("Ingrese un contacto válido.")
        }
    };

    _this.addOptionFromModal = function (newValue, edit, index) {
        _this.options = _this.options || [];    
        let value = newValue.trim().replace(/\"/g, '');
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        const isWaNumber = /^wa:\+\d{8,}(?:\|[^\|]+)?$/.test(value);
        const isFieldId = /^field:[a-zA-Z0-9]{8,}(?:\|[^\|]+)?$/.test(value);
        const isKeyword = _this.allowedKeywords.find(elem => elem.id === value);

        if (isEmail) {
            value = value.toLowerCase();
        }
    
        if (isEmail || isWaNumber || isKeyword || isFieldId) {
            const existsInOptions = _this.options.find(elem => elem === value);

            if (edit) {
                if (existsInOptions && _this.options[index].split('|')[0] !== value.split('|')[0]) {
                    this.errorMessage(
                        "Error: Contacto duplicado",
                        "El valor ingresado ya existe en la lista."
                    );
                    return;
                }
                _this.options[index] = value;
            } else {
                if (existsInOptions) {
                    this.errorMessage(
                        "Error: Contacto duplicado",
                        "El valor ingresado ya existe en la lista."
                    );
                    return;
                }
                _this.options.push(value);
            }
        } else {
            this.errorMessage(
                "Error: Contactos inválidos",
                'Valores inválido: ' + value
            );
        }
        _this.newOption = null;
    };
    
    _this.edit = function (index) {
        _this.editMode[index] = true;
        this.openOptionList(_this.allowedKeywords, _this.options, true, index);
        $timeout(function () {
            var ele = document.getElementById('chip_item_' + index);
            ele.focus();
        }, 100);
    }

    _this.copyOptions = function () {
        var copyElement = document.createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        var str = _this.options.reduce(function (acc, val) {
            acc = acc + '"' + val.replace('"', '') + '",';
            return acc;
        }, '')
        str = str.substring(0, str.length - 1);;
        copyElement.textContent = str;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    _this.pasteOptions = function () {
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_BODY')
            );
            return;
        }

        navigator.clipboard.readText().then(function (clipboardText) {
            var result = parseContactsFromClipboard(clipboardText);
            var validOptions = result.validOptions;
            var invalidValues = result.invalidValues;

            if (invalidValues.length > 0) {
                _this.errorMessage(
                    'Error: Contactos inválidos',
                    'Valores inválidos no agregados: ' + invalidValues.join(', ')
                );
            }

            if (validOptions.length === 0) {
                if (invalidValues.length === 0) {
                    _this.errorMessage(
                        $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_INVALID_TITLE'),
                        $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_ALT_DIR.ERR_PASTE_INVALID_BODY')
                    );
                }
                return;
            }

            $timeout(function () {
                _this.options = validOptions;
            });
        }).catch(function () {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_BODY')
            );
        });
    };

    _this.removeChip = function (index) {
        _this.options.splice(index, 1);
    };

    _this.removeAll = function () {
        _this.options = [];
    };

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }

    // MODAL
    this.openOptionList = function (allowedKeywords, options, edit, index) {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-builder/optionsListModal.html',
            controller: [
                "$uibModalInstance",
                "BuilderDataService",
                "toast",
                function ($uibModalInstance, BuilderDataService, toast) {
                    var _this = this;
                    this.activeTab = 0;
                    this.allowedKeywords = allowedKeywords;
                    this.edit = edit;
                    this.index = index;
                    this.options = options;
                    this.inputElements = [];
                    this.countryCodes = countryCodes;
                    
                    if (this.edit) {
                        const value = _this.options[_this.index];

                        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                            this.activeTab = 0;
                            this.email = value;
                        } 
                        else if (/^wa:(?:\+?\d{8,})(?:\|[^\|]+)?$/.test(value)) {
                            this.activeTab = 1;
                            const waParts = value.split('|');
                            let numberPart = waParts[0].replace('wa:', '');
                            let hasPlus = numberPart.startsWith('+');
                            let countryCode = '';
                            let localNumber = '';
                            if (hasPlus) {
                                const validCode = _this.countryCodes.find(entry => numberPart.startsWith(entry.code));
                                if (validCode) {
                                    countryCode = validCode.code;
                                    localNumber = numberPart.slice(countryCode.length);
                                    if (!/^\d+$/.test(localNumber)) {
                                        toast.error("Número de WhatsApp inválido.");
                                        return;
                                    }
                                    this.whatsappCode = countryCode;
                                    this.whatsappNumber = localNumber;
                                    this.whatsappTag = waParts[1] || '';
                                } else {
                                    toast.error("Número de WhatsApp inválido.");
                                    return;
                                }
                            } else {
                                this.whatsappCode = '';
                                this.whatsappNumber = numberPart;
                                this.whatsappTag = waParts[1] || '';
                            }
                        }
                        else if (/^field:[a-zA-Z0-9]{8,}(?:\|[^\|]+)?$/.test(value)) {
                            this.activeTab = 2;
                            const fieldParts = value.split('|');
                            this.fieldId = fieldParts[0].replace('field:', '');
                            const fieldElem = _this.inputElements.find(elem => elem.id === this.fieldId);
                            if (fieldElem) {
                                this.fieldName = fieldElem.name || fieldElem.label;
                            }
                        } 
                        else if (_this.allowedKeywords.find(elem => elem.id === value)) {
                            this.activeTab = 3;
                            this.keyword = value;
                        }
                    }
                    
                    this.getFlattenedInputElements = function (form) {
                        const processPages = function(pages, formType) {
                            let flattenedElements = [];
                    
                            pages.forEach((page, pageIndex) => {
                                // Procesar los elementos de la página con la lógica de indentación
                                const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType);
                                // Agregar los elementos procesados a la lista final
                                flattenedElements = flattenedElements.concat(elementsWithLevels);
                            });
                    
                            return flattenedElements;
                        };
                
                        let flattenedPages = processPages(form.pages, "Formulario");        
                        return flattenedPages;
                    };
                    this.getElementsWithLevels = function (fields, pageIndex, level, formType) {
                        return fields.flatMap(function (field) {
                            if (field.type === 'simplelist') {
                                const currentField = {
                                    ...field,
                                    level: level,
                                    disabled: false,
                                    form: formType,
                                    page: `Página ${pageIndex + 1}`
                                };
                                // No se procesan los elementos internos de simplelist
                                // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
                                // const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                                return [currentField]
                                // .concat(nodesProcessed);
                            }
                            if (field.type === 'group') {
                                const currentField = {
                                    ...field,
                                    level: level,
                                    disabled: false,
                                    form: formType,
                                    page: `Página ${pageIndex + 1}`
                                };
                                if (level === 1) { // Root level
                                    // Procesar los nodos dentro de 'group' despues de 'group'
                                    const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                                    return [currentField].concat(nodesProcessed);
                                } else {
                                    return [currentField];
                                }
                            }
                            return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
                        });
                    };

                    this.confirm = function() {
                        this.value = '';
                        this.valueOk = false;
                        switch (this.activeTab) {
                            case 0:
                                const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
                                if (isEmail) {
                                    this.value = this.email;
                                    this.valueOk = true;
                                } else {
                                    toast.error(`Error: Ingrese un email válido.`);
                                }
                                break;
                            case 1:
                                const isWaNumber = /^\d{8,}$/.test(this.whatsappNumber);
                                if (this.whatsappCode && isWaNumber) {
                                    if (this.whatsappTag?.trim() !== '') {
                                        const whatsappWithName = 'wa:' + this.whatsappCode + this.whatsappNumber + '|' + this.whatsappTag 
                                        this.value = whatsappWithName;
                                        this.valueOk = true;
                                    } else {
                                        const whatsapp = 'wa:' + this.whatsappCode + this.whatsappNumber;
                                        this.value = whatsapp;
                                        this.valueOk = true;
                                    }
                                } else {
                                    toast.error(`Error: Ingrese un número de whatsapp válido.`);
                                }
                                break;
                            case 2:
                                const isFieldId = this.fieldId;
                                if (isFieldId) {
                                    const fieldElem = this.inputElements.find(elem => elem.id === this.fieldId);
                                    if (fieldElem) {
                                        const fieldWithName = 'field:' + this.fieldId + '|' + (fieldElem.name || fieldElem.label);
                                        this.value = fieldWithName;
                                        this.valueOk = true;
                                    } else {
                                        toast.error('Algo salió mal al obtener el elemento')
                                    }
                                } else {
                                    toast.error(`Error: Seleccione un elemento de la lista.`);
                                }
                                break;
                            case 3:
                                if (this.keyword) {
                                    this.value = this.keyword;
                                    this.valueOk = true;
                                } else {
                                    toast.error(`Error: Seleccione una palabra de la lista.`);
                                }
                                break;                        
                            default:
                                break;
                        }
                        if (this.valueOk) {
                            const value = this.value.toLowerCase();
                            const exists = _this.options.some(option => option.toLowerCase().split('|')[0] === value.toLowerCase().split('|')[0]);
                            if (!exists || (exists && index!=undefined && _this.options[index].toLowerCase().split('|')[0] === value.toLowerCase().split('|')[0])) {
                                $uibModalInstance.close({ value: this.value, edit: _this.edit, index: _this.index });
                            } else {
                                toast.error('El valor ingresado ya existe en la lista de contactos.');
                            }
                        }
                    }

                    this.close = function () {
                        $uibModalInstance.close();
                    };

                    this.form = BuilderDataService.getForm();
                    this.inputElements = this.getFlattenedInputElements(_this.form);
                },
            ],
            controllerAs: "ctrl",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
        }).result.then((result) => {
            const { value, edit, index } = result || {};
            if (value) {
                _this.addOptionFromModal(value, edit, index);
            }
        }, function() { //dismiss
        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            hidehelp:'='
            ,legend: '@'
            ,help: '@'
            
        },
        replace: true,
        controller: options3Ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/options3Directive.html'
    };
};
